export default function PercentIndicator({ percentage }) {
  if (percentage === null) return null;
  
  const isPositive = percentage > 0;
  
  const isZero = percentage === 0;

  return (
    <div className="flex items-center mt-1 absolute bottom-[5%] right-[40%]">
      {isZero ? (
        <span className="text-gray-500 text-xs">No change</span>
      ) : (
        <>
          {isPositive ? (
            <svg className="w-3 h-3 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z" clipRule="evenodd" />
            </svg>
          ) : (
            <svg className="w-3 h-3 text-red-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" clipRule="evenodd" />
            </svg>
          )}
          <span className={`text-xs ml-1 ${isPositive ? 'text-green-500' : 'text-red-500'}`}>
            {Math.abs(percentage).toFixed(1)}%
          </span>
        </>
      )}
    </div>
  );
};